/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {createAction} from "helpers/createAction";
import ajax from "helpers/ajax";
import {AddToCartRequest, UpdateShoppingCartItemRequest} from "types/entities/Cart";
import {ShoppingCart} from "types/entities/ShoppingCart";
import {ShoppingCartItem} from "types/entities/ShoppingCartItem";
import {Driver} from "types/entities/Driver";

class CartAction {
    static readonly SET_CART = "CartAction.SetCart";

    static fetchCreateCart = (driver: Driver) => {
        return async dispatch => {
            try {
                let response: {cart: ShoppingCart} = await ajax.get("/online-venue/shop/create-cart", {
                    params: {driver_id: driver.id},
                });
                dispatch(CartAction.setCart(response.cart));
                return Promise.resolve(response.cart);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    // static fetchSetCart = (cart: ShoppingCart) => {
    //     return async dispatch => {
    //         try {
    //             dispatch(CartAction.setCart(cart));
    //             return Promise.resolve(cart)
    //         } catch (err) {
    //             console.log("fetchSetCart - Error");
    //             return Promise.reject(err);
    //         }
    //     }
    // }

    static fetchGetCart = (cart: ShoppingCart) => {
        return async dispatch => {
            try {
                let response: {cart: ShoppingCart} = await ajax.get("/online-venue/shop/get-cart/" + cart.id, {});
                dispatch(CartAction.setCart(response.cart));
                return Promise.resolve(response.cart);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    // static fetchGetCartByCode = (scanner: {code: string}) => {
    //     return async dispatch => {
    //         try {
    //             let response: {shoppingCart: ShoppingCart} = await ajax
    //                 .get("/api/venue/checkout/get-cart", {
    //                     params: {code: scanner.code}
    //                 });
    //             // dispatch(CartAction.setCart(response.shoppingCart));
    //             // return Promise.resolve(response.shoppingCart)
    //             dispatch(CartAction.setCart(response.shoppingCart));
    //             return Promise.resolve(response.shoppingCart)
    //         } catch (err) {
    //             console.log("fetchSetCart - Error");
    //             return Promise.reject(err);
    //         }
    //     }
    // }

    static fetchSetCartItem = (item: AddToCartRequest) => {
        return async dispatch => {
            try {
                let response: {cart: ShoppingCart} = await ajax.post("/online-venue/shop/add-to-cart", {
                    ...item,
                });
                dispatch(CartAction.setCart(response.cart));
                return Promise.resolve(response.cart);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    static fetchUpdateCartItem = (item: UpdateShoppingCartItemRequest) => {
        return async dispatch => {
            try {
                let response: {cart: ShoppingCart} = await ajax.post("/online-venue/shop/update-cart-item", {
                    ...item,
                });
                dispatch(CartAction.setCart(response.cart));

                return Promise.resolve(response.cart);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    static fetchRemoveCartItem = (item: ShoppingCartItem) => {
        return async dispatch => {
            try {
                let response: {
                    cart: ShoppingCart;
                } = await ajax.delete("/online-venue/shop/delete-cart-item/" + item.id);
                dispatch(CartAction.setCart(response.cart));
                return Promise.resolve(response.cart);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    static setCart(cart: ShoppingCart) {
        return createAction(CartAction.SET_CART, cart);
    }

    static clearShoppingCart() {
        return createAction(CartAction.SET_CART, null);
    }
}

export default CartAction;
